<template>
  <q-form @submit="this.onSubmit" class="ms-form ms-form--narrow">
    <div class="ms-form-grid ms-form-grid--single">
      <CustomSelect
        :options="this.workSets"
        label="Конструктив"
        optionValueKey="work_set_id"
        optionLabelKey="work_set_name"
        :value="this.formData.work_set_id || ''"
        @change="(value) => onChange('work_set_id', value)"
      />
      <div class="workset-form__check">
        <CustomCheckbox
          label="Без оплаты"
          :value="this.formData.without_pay"
          @change="(value) => onChange('without_pay', value)"
        />
      </div>
    </div>
    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>
<script>

import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { getWorkSetList } from "@/services/api/api";

export default {
  name: "add-handbook-contractor-workset",
  components: {CustomSelect, CustomModalFooter, CustomCheckbox},
  props: ['data'],
  data() {
    return {
      loading: false,
      workSets: [],
      formData: {
        without_pay: this.data?.body?.without_pay || false,
        work_set_id: this.data?.body?.work_set_id || '',
      }
    }
  },
  methods: {
    async getData(){
      const res = await getWorkSetList()
      this.workSets = res || []
    },
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="scss">
// Ширина и сетка — общие (ms-form-* в theme.scss)
.workset-form__check {
  margin: -4px 0 -4px -8px;
}
</style>
